module.exports = __webpack_public_path__ + "static/media/Arbok_gaussian2.b900f1c0.png";